import { Chart, Accessibility, numberFormat } from "highcharts"
import { HighchartHelper } from './HighchartHelper'

class ColumnHighchart {
  constructor(chart) {
    Object.assign(this, chart);

    this.columnCount = this.config.data.length
    this.decimals = this.maxDecimals(this.config.data.map(e => e.y))

    self = this
    new Chart(this.chart, {
      chart: {
        type: 'column',
        marginLeft: 0,
        backgroundColor: 'transparent',
        marginRight: 0,
        marginBottom: 40,
        height: 550,
        width: this.columnCount < 3 ? this.columnCount * 120 : null,
        style: {
          fontFamily: null
        },
        //margin: 0
      },
      xAxis: {
        categories: this.config.data ? this.config.data.map(e => e.name) : false,
        labels: {
          useHTML: true,
          enabled: true,
          format: '<strong class="subtitle">{value}</strong>',

        },
        lineWidth: 0,
        tickWidth: 0,
      },
      yAxis: {
        title: '',
        labels: {
          enabled: false,
        },
        gridLineWidth: 0,
        alignTicks: false,
        endOnTick: false,
        startOnTick: false,
      },
      title: {
        useHTML: true,
        style: {
          zIndex: -1,
          fontWeight: 'inherit',
        },
        text: `<div class="font-size-h3">${this.config.title}</div>`,
      },
      tooltip: HighchartHelper.tooltipTemplate(
        {
          headerFormat: '<span class="h4">{point.key}</span><br>',
          pointFormat: '<span>{point.description}</span>'
        }
      ),
      plotOptions: {
        backgroundColor: null,
        borderWidth: null,
        shadow: false,
        column: {
          pointPadding: 0,
          borderWidth: 0,
          groupPadding: 0,
          // pointWidth: null,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            verticalAlign: 'top',
            inside: true,
            style: {
              textOutline: 0,
            },
            useHTML: true,
            pointFormatter: function () {
              return `<strong class="font-size-h6 text-white">${numberFormat(this.y, self.decimals)}</strong>`;
            },
          },
        }
      },
      series: [{
        clip: false,

        shadow: false,
        showInLegend: false,
        colorByPoint: false,
        data: this.config.data
      }],
      credits: {
        enabled: false,
      },
    })
  }

  maxDecimals = arr => arr.reduce((max, n) => Math.max(max, (n.toString().split('.')[1] || '').length), 0)

}

export default ColumnHighchart
